import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const MD_BREAKPOINT = 744;

export default function initStepGroupCarousel() {
  const carousels = document.querySelectorAll(".step-group-swiper");

  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const wrapper = carousel.closest(".container") || carousel.parentElement;
    const controls = wrapper.querySelector(".carousel-controls");
    const prevBtn = controls?.querySelector(".carousel-button-prev");
    const nextBtn = controls?.querySelector(".carousel-button-next");
    const progressBar = controls?.querySelector(".carousel-progress-bar");

    let swiperInstance = null;

    function initSwiper() {
      if (swiperInstance) return;

      swiperInstance = new Swiper(carousel, {
        modules: [Navigation],
        slidesPerView: 1.065,
        spaceBetween: 24,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        on: {
          init: function () {
            updateProgress(this);
            updateControlsVisibility(this);
          },
          slideChange: function () {
            updateProgress(this);
          },
          progress: function () {
            updateProgress(this);
          },
          resize: function () {
            updateControlsVisibility(this);
            updateProgress(this);
          },
        },
        breakpoints: {
          744: {
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
          744: {
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
          },
          1280: {
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,
          },
        },
      });
    }

    function updateControlsVisibility(swiper) {
      if (!controls) return;
      const slidesPerView = swiper.params.slidesPerView;
      const totalSlides = swiper.slides.length;

      if (totalSlides <= slidesPerView) {
        controls.style.display = "none";
      } else {
        controls.style.display = "";
      }
    }

    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function updateProgress(swiper) {
      if (!progressBar) return;
      const total = swiper.slides.length;
      const perView =
        typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : 1;
      const visible = Math.min(perView / total, 1);
      const scrollProgress = Math.min(Math.max(swiper.progress, 0), 1);
      const progress = (visible + scrollProgress * (1 - visible)) * 100;
      progressBar.style.width = `${Math.min(progress, 100)}%`;
    }

    // Check screen size and init/destroy accordingly
    const mediaQuery = window.matchMedia(`(min-width: ${MD_BREAKPOINT}px)`);

    function handleMediaChange(e) {
      if (e.matches) {
        // Desktop: init swiper
        initSwiper();
        if (controls) controls.style.display = "";
      } else {
        // Mobile: destroy swiper, show as stack
        destroySwiper();
        if (controls) controls.style.display = "none";
      }
    }

    // Initial check
    handleMediaChange(mediaQuery);

    // Listen for changes
    mediaQuery.addEventListener("change", handleMediaChange);
  });
}
